import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/common/Navbar";
import "../styles/LoginPage.css";
import "../styles/common/roots.css";
import config from "../config/config";

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [loginError, setLoginError] = useState("");
  const [signupError, setSignupError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleForm = () => {
    const container = document.querySelector(".container");
    container.classList.toggle("active");
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value.trimEnd() });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Set loading to true when API request starts
    try {
      const res = await axios.post(
        `${config.API_URL}/api/auth/login`,
        formData
      );
      const token = res.data.token;
      localStorage.setItem("token", token);
      navigate("/"); // Navigate to home or other route
    } catch (err) {
      setLoginError(
        err.response?.data?.message ||
          "Login failed. Please check your credentials."
      );
    } finally {
      setIsLoading(false); // Set loading to false when API request finishes
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Set loading to true when API request starts
    if (formData.password !== formData.confirmPassword) {
      setSignupError("Passwords do not match");
      setIsLoading(false); // Set loading to false if validation fails
      return;
    }

    const passwordPattern =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/;
    if (!passwordPattern.test(formData.password)) {
      setSignupError(
        "Password must be at least 8 characters, include a number, one special character, and one uppercase letter."
      );
      setIsLoading(false); // Set loading to false if validation fails
      return;
    }
    //? Removed for Data Security
    // const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // if (!emailPattern.test(formData.email)) {
    //   setSignupError("Please enter a valid email address");
    //   setIsLoading(false); // Set loading to false if validation fails
    //   return;
    // }

    if (formData.username.trim() === "") {
      setSignupError("Username cannot be empty");
      setIsLoading(false); // Set loading to false if validation fails
      return;
    }

    try {
      await axios.post(`${config.API_URL}/api/auth/signup`, formData);
      toggleForm();
    } catch (err) {
      const errorMessage = err.response?.data?.message;

      if (errorMessage.includes("Username already taken")) {
        setSignupError("Username already taken");
        //? Removed for Data Security
        // } else if (errorMessage.includes("Email already registered")) {
        //   setSignupError("Email already registered");
      } else {
        setSignupError(errorMessage || "Error signing up");
      }
    } finally {
      setIsLoading(false); // Set loading to false when API request finishes
    }
  };

  return (
    <div className="">
      <Navbar />

      <section>
        <div className="container">
          <div className="user signinBx">
            <div className="imgBx">
              <img src="loginpage-login.svg" alt="" />
            </div>
            <div className="formBx">
              <form onSubmit={handleLogin}>
                <h2>Sign In</h2>
                <input
                  type="text"
                  name="username"
                  placeholder="Username"
                  onChange={handleChange}
                  required
                />
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  onChange={handleChange}
                  required
                />
                {loginError && <p className="formError">{loginError}</p>}
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`mt-2 ${isLoading ? "loading" : ""}`}
                >
                  {isLoading ? <div className="spinner"></div> : "Login"}
                </button>
                <div className="spinner"></div>{" "}
                <p className="signup">
                  Don't have an account?
                  <a href="#" onClick={toggleForm}>
                    Sign Up.
                  </a>
                </p>
              </form>
            </div>
          </div>
          <div className="user signupBx">
            <div className="formBx">
              <form onSubmit={handleSignup}>
                <h2>Create an account</h2>
                <input
                  type="text"
                  name="username"
                  placeholder="Username"
                  onChange={handleChange}
                  required
                />
                {/* //? Removed for Data Security */}
                {/* <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  onChange={handleChange}
                  required
                /> */}
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  onChange={handleChange}
                  required
                />
                <input
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  onChange={handleChange}
                  required
                />
                {signupError && <p className="formError">{signupError}</p>}
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`mt-2 ${isLoading ? "loading" : ""}`}
                >
                  {isLoading ? <div className="spinner"></div> : "Sign Up"}
                </button>

                <p className="signup">
                  Already have an account?
                  <a href="#" onClick={toggleForm}>
                    Sign in.
                  </a>
                </p>
              </form>
            </div>
            <div className="imgBx">
              <img src="loginpage-signup.svg" alt="" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
